.pages-col {
  flex-grow: 1;
  overflow-y: none;
  height: 100%;
  overflow: hidden; /* needed for scrolling width */
}

file-pages-viewer {
  display: block;
  height: 100%;
  width: 100%;
}

.rounded-corner-panel {
  border-radius: 8px;
  background-color: var(--color-grey-4, #666);
  --width: auto;
  --height: auto;
}

.right-col {
  flex: 0 0 auto;
  width: max-content;
  overflow-y: scroll;
  height: 100%;

  scrollbar-width: thin;
  scrollbar-color: grey transparent;
  scrollbar-gutter: stable;
}

.search-pane {
  position: absolute;
  width: 300px;
  height: 100%;
  top: 0;
  right: 0;
  overflow-y: scroll;
  background-color: var(--ion-background-color);
  z-index: 100;
}

.search-pane__close-button {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 101;
}

.document-viewer__right-sidebar {
  text-align: center;
  width: 320px;
  height: 100%;
}

.document-viewer__person-menu-container {
  padding: 1rem 0.5rem;
}

.search-results {
  position: absolute;
  top: 0;
  right: 0;
  width: 200px;
}

.search-result-list {
  width: 300px;
  padding-left: 8px;
}

.search-result-list .page {
  cursor: pointer;
}

.search-result-list .page .num {
  text-align: center;
  padding-bottom: 16px;
}

.search-result-list .snippets {
  color: white;
}

.file-page {
  background-color: white;
}

.thumb {
  display: inline-block;
  margin: 4px;
  position: relative;
  vertical-align: top;
  cursor: pointer;
}
.thumb img {
  display: block;
}

.thumb small {
  display: block;
  width: 160px; /* not wider than the image */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.document-viewer__finish-markups-button {
  z-index: 99;
  position: 'absolute';
  bottom: 0px;
  right: 0px;
}
